import {print_staff} from "../Pages/StaffOnFlight";

var ModalStaffSettings = {
    view: function (ctrl, args) {
        return [m("div.dm-overlay[id='debug']", [
            m("div.dm-table", [
                m("div.dm-cell[style='padding: 0 9px;']", [
                    m("div.dm-modal[style='min-width: 100%']", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[style='padding-right: 20px;']", "Настройки списка персонала"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalContainerStaffSettings.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 3px;']", [
                                    m("div[style='text-align: left;']", [
                                        m("div[style='padding: 3px 3px']", [
                                            m(".row[style='padding-left: 8px']", [
                                                m(".col-xs-6", [
                                                    m("input[name='setting'][id='tgo'][type='radio']", {
                                                        checked: localStorage.getItem("settingBlock") == "tgo" ? true : false,
                                                        onclick: function () {
                                                            document.getElementById("p_skill").hidden = true;
                                                            document.getElementById("p_tgo").hidden = false;
                                                            localStorage.setItem("settingBlock", "tgo");
                                                        }
                                                    }),
                                                    m("label[style='display: contents;'][for='tgo']", ["  Операция ТГО"])
                                                ]),
                                                m(".col-xs-6", [
                                                    m("input[name='setting'][id='skill'][type='radio']", {
                                                        checked: localStorage.getItem("settingBlock") == "skill" ? true : false,
                                                        onclick: function () {
                                                            document.getElementById("p_tgo").hidden = true;
                                                            document.getElementById("p_skill").hidden = false;
                                                            localStorage.setItem("settingBlock", "skill");
                                                        }
                                                    }),
                                                    m("label[style='display: contents;'][for='skill']", ["  Навык"])
                                                ])
                                            ]),

                                            m("div[id='p_tgo'][style='padding: 3px 0 3px 4px; margin-top: 4px; border: groove;']", {
                                                hidden: localStorage.getItem("settingBlock") == "tgo" ? false : true,
                                            }, [
                                                JSON.parse(localStorage.getItem("tgo")).map(function(field) {
                                                    return m("div", [
                                                        m("input[name='"+field.key+"'][id='"+field.key+"'][type='checkbox']", {
                                                            checked: field.check ? true : false,
                                                            onclick: function (val) {
                                                                let tgo_list = JSON.parse(localStorage.getItem("tgo"));
                                                                for(let i=0; i<tgo_list.length; i++) {
                                                                    if(tgo_list[i].key == field.key)
                                                                        tgo_list[i].check = val.currentTarget.checked;
                                                                }
                                                                localStorage.setItem("tgo", JSON.stringify(tgo_list));
                                                                m.redraw.strategy("none");
                                                            }
                                                        }),
                                                        m("label[style='display: contents;'][for='"+field.key+"']", [" "+field.value.serv_name ])
                                                    ])
                                                }),
                                            ]),

                                            m("div[id='p_skill'][style='padding: 3px 0 3px 4px; margin-top: 4px; border: groove;']", {
                                                hidden: localStorage.getItem("settingBlock") == "skill" ? false : true,
                                            }, [
                                                JSON.parse(localStorage.getItem("skill")).map(function(field) {
                                                    return m("div", [
                                                        m("input[name='"+field.key+"'][id='"+field.key+"'][type='checkbox']", {
                                                            checked: field.check ? true : false,
                                                            onclick: function (val) {
                                                                let skill_list = JSON.parse(localStorage.getItem("skill"));
                                                                for(let i=0; i<skill_list.length; i++) {
                                                                    if(skill_list[i].key == field.key)
                                                                        skill_list[i].check = val.currentTarget.checked;
                                                                }
                                                                localStorage.setItem("skill", JSON.stringify(skill_list));
                                                                m.redraw.strategy("none");
                                                            }
                                                        }),
                                                        m("label[style='display: contents;'][for='"+field.key+"']", [" "+field.value.skill_name ])
                                                    ])
                                                }),
                                            ]),
                                        ])

                                    ]),
                                    m("br"),
                                    m(".row[style='text-align: center;']", [
                                        m("button.btn.btn-warning.btn-lg", {
                                            onclick: function () {
                                                m.mount(document.getElementById("test"),
                                                    m.component(
                                                    {
                                                        controller: function () {
                                                            var self = this;
                                                            let settingBlock = localStorage.getItem("settingBlock");
                                                            let block_list = JSON.parse(localStorage.getItem(settingBlock));
                                                            var staff = [];
                                                            for(let i=0; i<block_list.length; i++) {
                                                                if(block_list[i].check) {
                                                                    var tgo = [], skill = [], key, item, arr_staff = [];
                                                                    item = {};
                                                                    item.key = settingBlock == 'tgo' ? block_list[i].value.serv_name : block_list[i].value.skill_name;
                                                                    for ( key in block_list[i].value.staff) {
                                                                        arr_staff.push(
                                                                            {
                                                                                "fio": block_list[i].value.staff[key],
                                                                                "confirm": block_list[i].value.confirm[key]
                                                                            }
                                                                        );
                                                                    }
                                                                    item.value = arr_staff;
                                                                    staff.push(item);
                                                                }
                                                            }
                                                            this.data = staff;
                                                            this.PV = localStorage.getItem("direction");
                                                            this.settingBlock = localStorage.getItem("settingBlock");

                                                        },
                                                        view: function (ctrl, args) {
                                                          return [
                                                                print_staff(ctrl.data, ctrl.PV, ctrl.settingBlock)
                                                              ]
                                                        }
                                                    })
                                                );
                                                m.redraw.strategy("diff");
                                                ModalContainerStaffSettings.close();
                                            }
                                        }, "Ок")
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        ])];
    }
};

export var ModalContainerStaffSettings = {
    container: null,
    init: function (settings) {
        ModalContainerStaffSettings.container = document.querySelector('#modalStaffSettings');
        var modalSetting = document.querySelector('#modalStaffSettings');
        if(!ModalContainerStaffSettings.container) {
            //modalSetting.parentNode.removeChild(modalSetting);
            ModalContainerStaffSettings.container = document.createElement('div');
            ModalContainerStaffSettings.container.id = 'modalStaffSettings';
            ModalContainerStaffSettings.container.hidden = true;
            document.body.appendChild(ModalContainerStaffSettings.container);

            m.mount(ModalContainerStaffSettings.container, m.component(ModalStaffSettings, {
                tgo: settings.tgo,
                skill: settings.skill
            }));
            m.redraw.strategy("diff");
        }

    },
    open: function () {
        ModalContainerStaffSettings.container = document.querySelector('#modalStaffSettings');
        if (ModalContainerStaffSettings.container) {
            ModalContainerStaffSettings.container.hidden = false;
            m.redraw.strategy("diff");
        }
    },
    close: function () {
        ModalContainerStaffSettings.container.hidden = true;
    }
};
